export default {
  messageBlocked: "El sistema ha bloqueado el mensaje",
  outboundCustomerLabel: "Enviado al cliente",
  customerActionCancel: "Cancelar",
  customerActionReceipt: "Recibo",
  messageSent: "¡Mensaje enviado!",
  agreementReached: "✅ ¡Reserva confirmada!",
  sendMessageError: "No se pudo enviar el mensaje",
  cancelConfirm: "¿Seguro que desea cancelar esta conversación?",
  conversationCancelled: "Conversación cancelada",
  cancelConversationError: "No se pudo cancelar la conversación",
  cancelReasonAdmin: "Cancelado por el staff",
  cancelReasonPartner: "Cancelado por el vendedor",
  reopenSession: "Reabrir handshake",
  reopenSessionBusy: "Reabriendo…",
  reopenSessionSuccess: "Handshake reabierto",
  reopenSessionError: "No se pudo reabrir el handshake",
  reopenSessionConfirmTitle: "¿Reabrir el handshake?",
  reopenSessionConfirmMessage:
    "La reserva vuelve a negociación para que se puedan cambiar fecha y hora en el chat con el cliente.",
  reopenSessionConfirm: "Reabrir handshake",
  loadingAudit: "Cargando datos de auditoría...",
  replyPlaceholder: "Responder al cliente...",
  adminReplyPlaceholder: "Responder al cliente como partner...",
  conversationNotFound: "Conversación no encontrada",
  bookingDetails: {
    title: "Detalles de la reserva",
    service: "Servicio reservado",
    activity: "Actividad",
    partyHeading: "Cantidad",
    visitHeading: "Fecha y hora solicitadas",
    visitFull: "({{datetime}})",
    visitNotSet: "Sin fecha/hora — acordar en el chat",
    visitOpenShort: "Fecha a acordar en el chat",
    visitScheduledMissingShort: "Sin fecha en la reserva",
    quantityUnknown: "No indicada",
    notes: "Notas del cliente",
    partyGuests_one: "{{count}} comensal",
    partyGuests_other: "{{count}} comensales",
    partyQuantity_one: "{{count}} unidad",
    partyQuantity_other: "{{count}} unidades",
  },
  started: "Iniciada {{date}}",
  conversationEmpty: "Sin mensajes. Responde para iniciar la conversación.",
  agreementReadOnly:
    "Esta negociación está cerrada. La reserva quedó confirmada en Flitrip.",
  confirmBooking: "Confirmar reserva",
  confirmBookingHint:
    "Úsalo cuando en el chat hayáis cerrado los detalles con el cliente. Indica fecha y hora de la experiencia y confirma en Flitrip.",
  confirmVisitDateLabel: "Fecha de la experiencia",
  confirmVisitTimeLabel: "Hora",
  confirmVisitRequired: "Introduce la fecha y la hora de la experiencia.",
  confirmVisitMustBeFuture:
    "La fecha y la hora de la experiencia deben ser futuras. Elige un horario posterior si necesitas corregir la reserva.",
  confirmSlotRequired:
    "Selecciona un turno o introduce una hora personalizada.",
  confirmSlotsLabel: "Turnos horarios",
  confirmSlotsLoading: "Cargando turnos…",
  confirmSlotsError: "No se pudieron cargar los turnos de este día.",
  confirmDayClosed: "Este día está cerrado en el calendario.",
  confirmNoSlots: "No hay turnos configurados para este día.",
  confirmSlotSpotsRemaining: "{{count}} plaza(s) disponibles",
  confirmSlotInsufficient:
    "Solo quedan {{remaining}} plaza(s) para {{partySize}} — puedes confirmar igualmente",
  confirmSlotFull: "Completo — puedes confirmar igualmente",
  confirmSlotUnlimited: "Disponible",
  confirmSlotRequested: "Solicitada",
  confirmCustomTimeLabel: "Hora personalizada",
  confirmCustomTimeHint:
    "Úsala si acordasteis una hora que no está en la lista. No consume capacidad del turno.",
  confirmVisitPrefillHint:
    "Prellenado desde la solicitud del cliente; cámbialo si acordasteis otro horario en el chat.",
  confirmBookingSuccess: "Reserva confirmada en Flitrip.",
  confirmBookingError: "No se pudo confirmar esta negociación.",
  acceptBooking: "Aceptar",
  acceptBookingBusy: "Aceptando…",
  acceptBookingHint:
    "Confirma la reserva en Flitrip cuando tú y el cliente hayáis acordado fecha y hora en el chat.",
  rejectBooking: "Rechazar",
  rejectBookingBusy: "Rechazando…",
  rejectBookingHint:
    "Rechaza esta solicitud. El cliente será notificado y la reserva no continuará.",
  rejectSessionTitle: "¿Rechazar esta reserva?",
  rejectSessionConfirm:
    "Se notificará al cliente que su solicitud fue rechazada.",
  rejectSessionAction: "Rechazar",
  confirmOverCapacityTitle: "¿Superar la capacidad del turno?",
  confirmOverCapacityMessage:
    "Este turno admite hasta {{maxCapacity}} plazas. Ya hay {{bookedCount}} confirmadas y quedan {{availableSpots}}, pero esta reserva es para {{partySize}}. Puedes confirmarla igualmente si quieres aceptarla.",
  confirmOverCapacityConfirm: "Confirmar de todos modos",
  conversationExpired: "Esta conversación ha expirado",
  conversationCancelledStatus: "Esta conversación está cancelada",
  backToDashboard: "Volver al panel",
  sessionIdShort: "ID de sesión",
  cancelSession: "Cancelar sesión",
  updated: "Actualizada",
  closed: "Cerrada",
  references: "Referencias",
  bookingId: "ID de reserva",
  sellerId: "ID de vendedor",
  auditTrail: "Historial de auditoría ({{count}} mensajes)",
  blockedCount: "Bloqueados: {{count}}",
  noMessages: "Aún no hay mensajes en esta conversación.",
  list: {
    quickStatusLabel: "Filtrar por estado",
    quickStatusAll: "Todas",
    adminTitle: "Panel de handshake",
    adminDescription:
      "Audita y monitoriza todas las conversaciones cliente-vendedor",
    conversationsFound_one: "{{count}} conversación encontrada",
    conversationsFound_other: "{{count}} conversaciones encontradas",
    loadingConversations: "Cargando conversaciones...",
    noConversationsFound: "No se han encontrado conversaciones",
    tryAdjustingFilters: "Prueba a ajustar los filtros",
    emptyHintAdmin: "Aún no hay conversaciones de handshake",
    clearFilters: "Limpiar filtros",
    loadFailedTitle: "No se pudieron cargar las conversaciones",
    loadFailedHint: "Comprueba tu conexión e inténtalo de nuevo.",
    loadFailedRetry: "Reintentar",
    loadFailedStale:
      "No se pudo actualizar la lista. Mostramos las conversaciones cargadas anteriormente.",
  },
} as const;
